<div class="container-fluid">
  <div class="row">
    <div class="col overflow-y-auto p-0">
      <header id="header">
        <nav class="navbar navbar-expand-lg">
          <div class="container-fluid">
            <a class="navbar-brand d-none d-md-flex">
              <img src="/assets/images/nhso-minimize.webp" alt="Logo" class="">
              <div>ระบบลงทะเบียนสิทธิหลักประกันสุขภาพแห่งชาติ</div>
            </a>
          </div>
        </nav>
      </header>
      <div id="content">
        <div class="ps-3 pt-3 pe-3 pb-0">
          <app-loading></app-loading>
          <div class="min-vh-80">
            <div class="container">
              <app-header></app-header>
              <app-right-search-by-pid [showRegisterPanel]="false"></app-right-search-by-pid>
            </div>
          </div>
          <div class="container-fluid">
            <footer class="py-3 my-4">
<!--              <ul class="nav justify-content-center border-bottom pb-3 mb-3">-->
<!--                <li class="nav-item"><a href="#" class="nav-link px-2 text-muted">Footer</a></li>-->
<!--              </ul>-->
<!--              <p class="text-center text-muted">© 2022 Company, Inc</p>-->
            </footer>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
